import React, { SetStateAction, useState } from "react";

import { TextField } from "@mui/material";
import { Stack } from "@mui/material";
import { TableRow } from "@mui/material";

import BasicPopover from "../../../Components/Popover";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { StyledTableCell, StyledTableHead, StyledTableHeadColor, StyledTableHeadLeft, } from "../../../Styles/tabelCellStyled/customTableCell";
import { IEficienciaAlimBeneficiario } from "../../../Interfaces/beneficiarios/beneficiario";
import { PatternFormat } from "react-number-format";
import PhoneInput from "react-phone-number-input";
import { formatarNumero_ao_digitar } from "../../../Func_genericas/formatar_numero_formato_pt";

interface IEficAlimentarProps {
  book: IEficienciaAlimBeneficiario | undefined;
  set_book: React.Dispatch<SetStateAction<IEficienciaAlimBeneficiario | undefined>>
  error_nif: boolean;
  error_email: boolean;
  error_nome: boolean;
  error_nifap: boolean;
  // set_error_email: React.Dispatch<React.SetStateAction<boolean>>;
  set_error_nif: React.Dispatch<React.SetStateAction<boolean>>;
  set_flag_editado: React.Dispatch<React.SetStateAction<boolean>>;
  setError_nifap: React.Dispatch<React.SetStateAction<boolean>>;
}

export const IdentifEficienciaAlimentarEdit: React.FC<IEficAlimentarProps> = ({
  book,
  set_book,
  error_nif,
  error_email,
  error_nome,
  error_nifap,
  set_error_nif,
  setError_nifap, 
  set_flag_editado,

}) => {

  const [error_bovinos_carne, setError_bovinos_carne] = useState<boolean>(false);

  const message_apenas_numero = ("Introduza apenas números");
  const campos_NaoNumericos = ["nif", "nifap", "telefone", "telefone_S", "telemvel_S", "bovinos_carne"]


  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    const isCampoNumerico = campos_NaoNumericos.includes(name);

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "bovinos_carne") {
          setError_bovinos_carne(false);
        } else if (name === "nif") {
          set_error_nif(false)
        } else if (name === "nifap") {
          setError_nifap(false)
        }
      } else {
        if (name === "bovinos_carne") {
          setError_bovinos_carne(true);
        } else if (name === "nif") {
          set_error_nif(true)
        } else if (name === "nifap") {
          setError_nifap(true)
        }
      }
      set_book((prev: any) => ({
        ...prev,
        [name]: formatarNumero_ao_digitar(valorSemFormatar),
      }));
    } else {
      set_book((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <TableRow>
        <StyledTableHeadColor colSpan={2}>
          Identificação do operador
        </StyledTableHeadColor>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft width="20%">
          Nome do Beneficiário
        </StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="nome"
            value={book?.nome === undefined ? "" : book.nome}
            onChange={ onInputChange}
            error={error_nome}
            helperText={error_nome === true ? "Nome inválido" : ""}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>NIF </StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="nif"
            value={book?.nif}
            onChange={ onInputChange}
            error={error_nif}
            helperText={error_nif === true ? "NIF inválido" : ""}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>NIFAP</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="nifap"
            value={book?.nifap}
            onChange={ onInputChange}
            error={error_nifap}
            helperText={error_nifap ? message_apenas_numero : ""}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Morada</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="morada"
            value={book?.morada}
            onChange={ onInputChange}

          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Localização</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="localizacao"
            value={book?.localizacao}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Código Postal</StyledTableHeadLeft>
        <StyledTableCell>
          <PatternFormat
            format="%%%%-%%%"
            customInput={TextField}
            variant="filled"
            fullWidth
            patternChar="%"
            value={book?.codig_postal || ""}
            name="codig_postal"
            margin="normal"
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Freguesia</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="freguesia"
            value={book?.freguesia}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableHeadLeft>Concelho</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="concelho"
            value={book?.concelho}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Contacto telefónico </StyledTableHeadLeft>
        <StyledTableCell>
          <PhoneInput
            name="telefone"
            defaultCountry="PT"
            placeholder="Número de telefone"
            value={"+351" + (book?.telefone === undefined ? '' : book?.telefone)}
            onChange={(e)=> onInputChange}
            style={{ width: "90%", height: 51, }}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Correio electrónico </StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="email"
            value={book?.email}
            onChange={ onInputChange}
            error={error_email}
            helperText={error_email === true ? "Email inválido" : ""}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadColor colSpan={2}>
          <Stack direction="row">
            Sócio gerente ou representante (Quando aplicável)
            <BasicPopover text="Identificação da exploração" />
          </Stack>
        </StyledTableHeadColor>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Cargo</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="cargo_s"
            value={book?.cargo_s}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Nome</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="nome_S"
            value={book?.nome_S}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Morada</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="morada_S"
            value={book?.morada_S}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Telefone</StyledTableHeadLeft>
        <StyledTableCell>
          <PhoneInput
            name="telefone_S"
            defaultCountry="PT"
            placeholder="Número de telefone"
            value={"+351" + (book?.telefone_S === undefined ? '' : book.telefone_S)}
            onChange={(e)=> onInputChange}
            style={{ width: "90%", height: 51, }} />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Telemóvel</StyledTableHeadLeft>
        <StyledTableCell>
          <PhoneInput
            name="telemvel_S"
            defaultCountry="PT"
            placeholder="Número de telefone"
            value={"+351" + (book?.telemvel_S === undefined ? '' : book.telemvel_S)}
            onChange={(e)=> onInputChange}
            style={{ width: "90%", height: 51, }} />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Correio electrónico</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="email_S"
            value={book?.email_S}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadColor colSpan={2}>
          Identificação da exploração
        </StyledTableHeadColor>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Local da sede</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="local_sede_E"
            value={book?.local_sede_E}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Cód. Postal</StyledTableHeadLeft>
        <StyledTableCell>
          <PatternFormat
            format="%%%%-%%%"
            customInput={TextField}
            variant="filled"
            fullWidth
            patternChar="%"
            value={book?.codigo_postal_E || ""}
            name="codigo_postal_E"
            margin="normal"
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Concelho</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="concelho_E"
            value={book?.concelho_E}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Freguesia</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="freguesia_E"
            value={book?.freguesia_E}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadColor colSpan={2}>
          Efetivo Pecuário (CN):
        </StyledTableHeadColor>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Bovinos de carne (CN)</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="bovinos_carne"
            value={book?.bovinos_carne}
            onChange={ onInputChange}
            error={error_bovinos_carne}
            helperText={error_bovinos_carne ? message_apenas_numero : ""}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>CCDR a que pertence:</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="ccdr"
            value={book?.ccdr}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Assistência Técnica</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="assistencia"
            value={book?.assistencia}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableHeadLeft>Identificação do OC</StyledTableHeadLeft>
        <StyledTableCell>
          <CustomTextField
            name="identificacao_oc"
            value={book?.identificacao_oc}
            onChange={ onInputChange}
          />
        </StyledTableCell>
      </TableRow>
    </>
  );
};
